import server from "./server";

let translator = {
    langs: {
        items: null,
        def: 0,
        current: 0
    },
    setCurrent(v) {
        this.langs.current = v;
        localStorage.setItem('maxman_lang', v);
    },
    waitInit() {
        var p = new Promise((cb) => {
            let loop = () => {
                if (this.langs.items) {
                    cb();
                } else {
                    setTimeout(() => {
                        loop();
                    }, 10);
                }
            };
            loop();
        });

        return p;
    },
    getCurrent() {
        return this.langs.current;
    },
    init() {
        if (localStorage.getItem('maxman_lang')) {
            this.langs.current = localStorage.getItem('maxman_lang');
        }else{
            this.langs.current = 1;
        }
        server.post("api/public/langs").then((r) => {
            this.langs.items = r.data.langs;
            this.langs.def = r.data.defLang;
            if (localStorage.getItem('maxman_lang')) {
                this.langs.current = localStorage.getItem('maxman_lang');
            } else {
                this.langs.current = this.langs.def;
            }

        });
    }
};

translator.init();

export default translator;




// WEBPACK FOOTER //
// ./src/public_app/api/translator.js